// The portal's loading state (components/Spinner): antd Spin, large, with a short delay so quick loads never flash.
import { InboxOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import type { ReactNode } from "react";

export default function Spinner({ tip }: { tip?: string }) {
  return (
    <div className="d-flex flex-column align-items-center justify-content-center py-5 ct-muted" style={{ minHeight: 160 }}>
      <Spin size="large" delay={300} />
      {tip && <div className="mt-3">{tip}</div>}
    </div>
  );
}

export function EmptyState({ title, hint, icon }: { title: string; hint?: string; icon?: ReactNode }) {
  return (
    <div className="ct-empty">
      {icon ?? <InboxOutlined />}
      <div style={{ fontWeight: 700, color: "#44444f" }}>{title}</div>
      {hint && <div className="mt-1" style={{ fontSize: 13 }}>{hint}</div>}
    </div>
  );
}
